import {BackendForAppErrorCode, StampRowType} from '../bfa-api/models';

export class AbortedByStampActionError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.AbortedByStampAction);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class AiNotEnoughQuotaError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.AiNotEnoughQuota);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class AiServicesNotEnabledError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.AiServicesNotEnabled);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class ArchivationIsNotAuthorizedForDocumentError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.ArchivationIsNotAuthorizedForDocument);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class ClickFinderNodeNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.ClickFinderNodeNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class ConditionNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.ConditionNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class DocumentCurrentlyNotEditableError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.DocumentCurrentlyNotEditable);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class DocumentCurrentlyNotStampableError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.DocumentCurrentlyNotStampable);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class DocumentDeletedError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.DocumentDeleted);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class DocumentNameAlreadyExistsError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.DocumentNameAlreadyExists);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class DocumentIsLockedByOtherUserError extends Error {
    private readonly lockedSince: Date;
    private readonly lockedByUserId: string;
    private readonly lockedByUserFullName: string;

    public constructor(lockedSince: Date, lockedByUserId: string, lockedByUserFullName: string) {
        super(BackendForAppErrorCode.DocumentIsLockedByOtherUser);
        this.lockedSince = lockedSince;
        this.lockedByUserId = lockedByUserId;
        this.lockedByUserFullName = lockedByUserFullName;
        Object.setPrototypeOf(this, new.target.prototype);
    }

    public getLockedSince(): Date {
        return this.lockedSince;
    }

    public getLockedByUserId(): string {
        return this.lockedByUserId;
    }

    public getLockedByUserFullName(): string {
        return this.lockedByUserFullName;
    }
}

export class DocumentIsNotLockedError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.DocumentIsNotLocked);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class DocumentNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.DocumentNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class IconNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.IconNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class InvalidArgumentError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.InvalidArgument);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class InvalidDocumentIdError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.InvalidDocumentId);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class InvalidModelStateError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.InvalidModelState);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class InvalidStampActionResponseError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.InvalidStampActionResponse);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class InvalidTagValueError extends Error {
    private readonly failedTagId: string | undefined;

    public constructor(tagId: string | undefined) {
        super(BackendForAppErrorCode.InvalidTagValue);
        this.failedTagId = tagId;
        Object.setPrototypeOf(this, new.target.prototype);
    }

    public getFailedTagId(): string | undefined {
        return this.failedTagId;
    }
}

export class LanguageCultureNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.LanguageCultureNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class MagnetNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.MagnetNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class NoReadableDocumentsError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.NoReadableDocuments);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class NotAuthorizedError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.NotAuthorized);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class ReadonlyTagValueError extends Error {
    private readonly failedTagId: string | undefined;

    public constructor(tagId: string | undefined) {
        super(BackendForAppErrorCode.ReadonlyTagValue);
        this.failedTagId = tagId;
        Object.setPrototypeOf(this, new.target.prototype);
    }

    public getFailedTagId(): string | undefined {
        return this.failedTagId;
    }
}

export class RequiredTagValueError extends Error {
    private readonly failedTagId: string | undefined;

    public constructor(tagId: string | undefined) {
        super(BackendForAppErrorCode.RequiredTagValue);
        this.failedTagId = tagId;
        Object.setPrototypeOf(this, new.target.prototype);
    }

    public getFailedTagId(): string | undefined {
        return this.failedTagId;
    }
}

export class SearchQueryNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.SearchQueryNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class SearchResultsNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.SearchResultsNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class ServerMaintenanceError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.ServerMaintenance);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class StampedValueIsNotAllowedError extends Error {
    private readonly tagDefinitionId: string;
    private readonly stampRowId: string;
    private readonly stampRowType: StampRowType;

    public constructor(tagDefinitionId: string, stampRowId: string, stampRowType: StampRowType) {
        super(BackendForAppErrorCode.StampedValueIsNotAllowed);
        this.tagDefinitionId = tagDefinitionId;
        this.stampRowId = stampRowId;
        this.stampRowType = stampRowType;
        Object.setPrototypeOf(this, new.target.prototype);
    }

    public getTagDefinitionId(): string {
        return this.tagDefinitionId;
    }

    public getStampRowId(): string {
        return this.stampRowId;
    }
}

export class StampInputRequiredError extends Error {
    private readonly tagDefinitionId: string;
    private readonly stampRowId: string;
    private readonly stampRowType: StampRowType;

    public constructor(tagDefinitionId: string, stampRowId: string, stampRowType: StampRowType) {
        super(BackendForAppErrorCode.StampInputRequired);
        this.tagDefinitionId = tagDefinitionId;
        this.stampRowId = stampRowId;
        this.stampRowType = stampRowType;
        Object.setPrototypeOf(this, new.target.prototype);
    }

    public getTagDefinitionId(): string {
        return this.tagDefinitionId;
    }

    public getStampRowId(): string {
        return this.stampRowId;
    }
}

export class StampIsNotVisualError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.StampIsNotVisual);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class StampNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.StampNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class StampTagNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.StampTagNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class StampWithDuplicatedMmsNotUsableError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.StampWithDuplicatedMmsNotUsable);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class StreamNotAvailableError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.StreamNotAvailable);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class TagDefinitionNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.TagDefinitionNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class TagDefinitionVersionChangedError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.TagDefinitionVersionChanged);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class TagNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.TagNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class UserNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.UserNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class VaultNotFoundError extends Error {
    public constructor() {
        super(BackendForAppErrorCode.VaultNotFound);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
